import React, { useState, } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../general/General.css';
import { handleCreateAddressArea } from "../../service/AddressApi"; // Import the function
import { translateText } from "../../service/UtilApi"; // Import the function
import { useCheckAccess } from "../../utils/Utilities";
import { fetchAddressAreaByPin } from "../../service/AddressApi"; // Assuming this is defined in the service file
import { Loading } from "../../components/shared";
const PinCodeLookup = () => {
    useCheckAccess('AddressRW'); // Check if the user is logged in (if no user data, redirect to login)
    const [pinCode, setPinCode] = useState('');
    const [addressData, setAddressData] = useState(null);
    const [isApproved, setIsApproved] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [country, setCountry] = useState('India'); // Country selection state (ISO 3166-1 Alpha-2 Code)
    //const [addressAreas, setAddressAreas] = useState({}); // Initialize as an object
    const [manualAddress, setManualAddress] = useState({ // State for manual address
        Name: '',
        District: '',
        State: '',
        Country: 'India', // Default to 'IN' for India
        Pincode: '',
    });

    const navigate = useNavigate(); // Initialize the useNavigate hook

    // List of countries (ISO 3166-1 Alpha-2 Codes)
    const countriesList = [
        { code: 'India', name: 'India' },
        { code: 'United States', name: 'United States' },
        { code: 'Canada', name: 'Canada' },
        { code: 'United Kingdom', name: 'United Kingdom' },
        { code: 'Australia', name: 'Australia' },
        { code: 'Germany', name: 'Germany' },
        { code: 'France', name: 'France' },
        { code: 'Italy', name: 'Italy' },
        { code: 'Spain', name: 'Spain' },
        { code: 'Brazil', name: 'Brazil' },
        { code: 'Russia', name: 'Russia' },
        { code: 'China', name: 'China' },
        { code: 'Japan', name: 'Japan' },
        { code: 'South Africa', name: 'South Africa' },
        { code: 'Mexico', name: 'Mexico' },
        { code: 'South Korea', name: 'South Korea' },
        { code: 'Nigeria', name: 'Nigeria' },
        { code: 'Philippines', name: 'Philippines' },
        { code: 'United Arab Emirates', name: 'United Arab Emirates' },
        { code: 'Singapore', name: 'Singapore' },
        { code: 'Sweden', name: 'Sweden' },
        { code: 'Norway', name: 'Norway' },
        { code: 'Finland', name: 'Finland' },
        { code: 'Netherlands', name: 'Netherlands' },
        { code: 'Switzerland', name: 'Switzerland' },
        { code: 'Belgium', name: 'Belgium' },
        { code: 'Poland', name: 'Poland' },
        { code: 'Denmark', name: 'Denmark' },
        { code: 'Argentina', name: 'Argentina' },
        { code: 'Egypt', name: 'Egypt' },
        { code: 'Israel', name: 'Israel' },
        { code: 'Greece', name: 'Greece' },
        { code: 'Portugal', name: 'Portugal' },
        { code: 'Vietnam', name: 'Vietnam' },
        { code: 'Malaysia', name: 'Malaysia' },
        { code: 'Thailand', name: 'Thailand' },
        { code: 'Indonesia', name: 'Indonesia' },
        { code: 'Kuwait', name: 'Kuwait' },
        { code: 'Qatar', name: 'Qatar' },
        { code: 'Lithuania', name: 'Lithuania' },
        { code: 'Estonia', name: 'Estonia' },
        { code: 'Latvia', name: 'Latvia' },
        { code: 'Luxembourg', name: 'Luxembourg' },
        { code: 'Cyprus', name: 'Cyprus' },
        { code: 'Iceland', name: 'Iceland' },
        { code: 'Bulgaria', name: 'Bulgaria' },
        { code: 'Romania', name: 'Romania' },
        { code: 'Hungary', name: 'Hungary' },
        { code: 'Slovakia', name: 'Slovakia' },
        { code: 'Croatia', name: 'Croatia' },
        { code: 'Slovenia', name: 'Slovenia' },
        { code: 'Serbia', name: 'Serbia' },
        { code: 'Ukraine', name: 'Ukraine' },
        { code: 'Bosnia and Herzegovina', name: 'Bosnia and Herzegovina' },
        { code: 'North Macedonia', name: 'North Macedonia' },
        { code: 'Albania', name: 'Albania' },
        { code: 'Armenia', name: 'Armenia' },
        { code: 'Azerbaijan', name: 'Azerbaijan' },
        { code: 'Georgia', name: 'Georgia' },
        { code: 'Belarus', name: 'Belarus' },
        { code: 'Moldova', name: 'Moldova' },
        { code: 'Tajikistan', name: 'Tajikistan' },
        { code: 'Kyrgyzstan', name: 'Kyrgyzstan' },
        { code: 'Turkmenistan', name: 'Turkmenistan' },
        { code: 'Uzbekistan', name: 'Uzbekistan' },
        { code: 'Mongolia', name: 'Mongolia' },
        { code: 'Nepal', name: 'Nepal' },
        { code: 'Bangladesh', name: 'Bangladesh' },
        { code: 'Sri Lanka', name: 'Sri Lanka' },
        { code: 'Myanmar', name: 'Myanmar' },
        { code: 'Cambodia', name: 'Cambodia' },
        { code: 'Laos', name: 'Laos' },
        { code: 'Bhutan', name: 'Bhutan' },
        { code: 'Maldives', name: 'Maldives' }
    ];

    // Handle PIN code input change
    const handlePinCodeChange = (e) => {
        setPinCode(e.target.value);
    };

    // Handle Country change
    const handleCountryChange = (e) => {
        setCountry(e.target.value);
        // Reset address data if country changes
        setAddressData(null);
        setManualAddress({ ...manualAddress, Country: e.target.value });
    };

    // Handle manual address input change
    const handleManualAddressChange = (e) => {
        setManualAddress({
            ...manualAddress,
            [e.target.name]: e.target.value
        });
    };

    // Function to handle changes in editable fields (both English and Tamil)
    const handleAddressEditChange = (index, field, value, lang) => {
        const updatedData = [...addressData];  // Make a copy of the address data array

        if (lang === 'tamil') {
            updatedData[index] = {
                ...updatedData[index],
                [`${field}`]: value
            };
        }
        else {
            updatedData[index] = {
                ...updatedData[index],

                [`${field}`]: value
            };
        }
        setAddressData(updatedData); // Update the state with the modified address data
    };

    // Fetch address data from the India Post API if country is India
    const getAddressDetails = async () => {
        if (!pinCode) {
            alert('Please enter a PIN code!');
            return;
        }
        setLoading(true);
        setError('');

        if (country === 'India') {  // Check if the selected country is India (ISO code: 'IN')
            try {
                // Make the API call to the India Post API
                const response = await axios.get(`https://api.postalpincode.in/pincode/${pinCode}`);
                // Check if the response is successful and contains post office data
                if (response.data[0].Status === "Success" && response.data[0].PostOffice.length > 0) {
                    // Translate each address field to Tamil dynamically
                    /* const translatedData = await Promise.all(
                         response.data[0].PostOffice.map(async (address) => {
                             const translatedName = await translateText(address.Name);
                             const translatedDistrict = await translateText(address.District);
                             const translatedState = await translateText(address.State);
                             const translatedCountry = await translateText(address.Country);
                             const translatedDescription = await translateText(address.Description);
                             const translatedCircle = await translateText(address.Circle);
                             const translatedDivision = await translateText(address.Division);
                             const translatedRegion = await translateText(address.Region);
                             const translatedBlock = await translateText(address.Block);
                             return {
                                 ...address,
                                 name_tamil: translatedName,
                                 district_tamil: translatedDistrict,
                                 state_tamil: translatedState,
                                 country_tamil: translatedCountry,
                                 description_tamil: translatedDescription || "",
                                 circle_tamil: translatedCircle || "",
                                 division_tamil: translatedDivision || "",
                                 region_tamil: translatedRegion || "",
                                 block_tamil: translatedBlock || ""
                             };
                         })
                     );
 
                     // Set address data to the translated list of post offices
                     setAddressData(translatedData);*/


                    const translatedData = [];

                    for (const address of response.data[0].PostOffice) {
                        const translatedName = await translateText(address.Name);
                        const translatedDistrict = await translateText(address.District);
                        const translatedState = await translateText(address.State);
                        const translatedCountry = await translateText(address.Country);
                        //  const translatedDescription = await translateText(address.Description);
                        //  const translatedCircle = await translateText(address.Circle);
                        // const translatedDivision = await translateText(address.Division);
                        // const translatedRegion = await translateText(address.Region);
                        const translatedBlock = await translateText(address.Block);

                        translatedData.push({
                            ...address,
                            name_tamil: translatedName,
                            district_tamil: translatedDistrict,
                            state_tamil: translatedState,
                            country_tamil: translatedCountry,
                            // description_tamil: translatedDescription || "",
                            //  circle_tamil: translatedCircle || "",
                            // division_tamil: translatedDivision || "",
                            // region_tamil: translatedRegion || "",
                            block_tamil: translatedBlock || ""
                        });
                    }

                    setAddressData(translatedData);


                } else {
                    setError('No address details found for the given PIN code.');
                }
                setLoading(false);
            } catch (error) {
                setLoading(false);
                setError('Failed to fetch address details.');
            }

        } else {
            // For non-India countries, use manual address and translate fields
            const translatedManualAddress = {
                ...manualAddress,
            };
            setAddressData([translatedManualAddress]);
            setLoading(false);
        }
    };


    // Function to handle form submission and save the data
    const approveAddress = async () => {
        try {
            setLoading(true); // Start loading
            // If the country is India, submit the address data from the API response
            if (country === 'India') {
                // Here, addressData is the array that holds the updated values
                const result = await handleCreateAddressArea({
                    addressArea: addressData,  // Send the whole array of addresses
                });
                setLoading(false);
                if (result) {
                    setIsApproved(true); // Mark as approved
                    navigate(`/address-sub-area/update/${addressData[0].Pincode}`); // Redirect to update page
                } else {
                    alert('Failed to approve and save the addresses.');
                }
            } else {
                // If the country is not India, submit the manually entered address data
                const result = await handleCreateAddressArea({
                    addressArea: [manualAddress],  // Send the manually entered address as an array
                });
                if (result) {
                    alert('Address approved and saved successfully!');
                    setIsApproved(true); // Mark as approved
                    navigate(`/address-area/view/${manualAddress.Pincode}`); // Redirect to update page
                } else {
                    alert('Failed to approve and save the address.');
                }
            }
        } catch (error) {
            setLoading(false);
            alert('Failed to submit the addresses.');
        }
    };


    const checkAddressExists = async (pincode) => {
        if (pincode) {
            setLoading(true); // Start loading

            try {
                const data = await fetchAddressAreaByPin(pincode, 'false'); // Fetch address data based on PIN

                if (data?.addressAreaList?.length > 0) {
                    navigate(`/address-area/view/${pincode}`); // If address exists, navigate to update page
                } else {
                    // If no address data found, get details from India Post API or allow manual entry
                    await getAddressDetails(); // Fetch address from API or allow manual entry
                }
            } catch (error) {
                setError("Failed to fetch address data");
            } finally {
                setLoading(false); // End loading
            }
        } else {
            setError("Invalid PIN received");
            setLoading(false); // End loading
        }
    };

    if (loading) {
        return (
            <div className="general_body">
                <Loading />
            </div>
        );
    }
    return (
        <div className="general_parent">
            <div className="general_container">
                <div className="general_body">
                    <h2>பின் குறியீடு முகவரி தேடல்</h2>
                    <br />
                    <label htmlFor="country">நாட்டைத் தேர்ந்தெடுக்கவும்:</label>
                    <select id="country" value={country} onChange={handleCountryChange}
                        className='auth_select'>
                        {countriesList.map((countryItem) => (
                            <option key={countryItem.code} value={countryItem.code}>
                                {countryItem.name}
                            </option>
                        ))}
                    </select>
                    {/* PIN Code input and button will only show if country is India */}
                    {country === 'India' && (
                        <>
                            <label htmlFor="pinCode">பின் குறியீட்டை உள்ளிடவும்:</label>
                            <input
                                type="text"
                                id="pinCode"
                                value={pinCode}
                                onChange={handlePinCodeChange}
                                maxLength={6}
                                required
                                inputMode="numeric"
                            />


                            <button onClick={() => checkAddressExists(pinCode)} disabled={loading}>
                                {loading ? 'ஏற்றுகிறது...' : 'முகவரியைத் தேடு'}
                            </button>
                        </>
                    )}

                    {error && <p style={{ color: 'red' }}>{error}</p>}
                    <br />
                    <hr />

                    {/* Address data display and approval/rejection */}
                    {addressData && !isApproved && (
                        <div>
                            <h3>முகவரி விவரங்கள்:</h3>
                            {country === 'India' ? (
                                addressData.map((address, index) => (
                                    <div key={index}>
                                        <p><strong>பின் குறியீடு:</strong> {address.Pincode} </p>
                                        {/* Editable fields for both English and Tamil */}
                                        <p><strong>Post:</strong>
                                            <input
                                                type="text"
                                                value={address.Name}
                                                onChange={(e) => handleAddressEditChange(index, 'Name', e.target.value, 'en')}
                                            />
                                            In Tamil :
                                            <input
                                                type="text"
                                                value={address.name_tamil}
                                                onChange={(e) => handleAddressEditChange(index, 'name_tamil', e.target.value, 'tamil')}
                                            />
                                        </p>
                                        <p><strong>Taluk:</strong>
                                            <input
                                                type="text"
                                                value={address.Block}
                                                onChange={(e) => handleAddressEditChange(index, 'Block', e.target.value, 'en')}
                                            />
                                            In Tamil :
                                            <input
                                                type="text"
                                                value={address.block_tamil}
                                                onChange={(e) => handleAddressEditChange(index, 'block_tamil', e.target.value, 'tamil')}
                                            />
                                        </p>
                                        <p><strong>District:</strong>
                                            <input
                                                type="text"
                                                value={address.District}
                                                onChange={(e) => handleAddressEditChange(index, 'District', e.target.value, 'en')}
                                            />
                                            In Tamil :
                                            <input
                                                type="text"
                                                value={address.district_tamil}
                                                onChange={(e) => handleAddressEditChange(index, 'district_tamil', e.target.value, 'tamil')}
                                            />
                                        </p>
                                        <p><strong>State:</strong>
                                            <input
                                                type="text"
                                                value={address.State}
                                                onChange={(e) => handleAddressEditChange(index, 'State', e.target.value, 'en')}
                                            />
                                            In Tamil :
                                            <input
                                                type="text"
                                                value={address.state_tamil}
                                                onChange={(e) => handleAddressEditChange(index, 'state_tamil', e.target.value, 'tamil')}
                                            />
                                        </p>
                                        <p><strong>Country:</strong>
                                            <input
                                                type="text"
                                                value={address.Country}
                                                onChange={(e) => handleAddressEditChange(index, 'Country', e.target.value, 'en')}
                                            />
                                            In Tamil :
                                            <input
                                                type="text"
                                                value={address.country_tamil}
                                                onChange={(e) => handleAddressEditChange(index, 'country_tamil', e.target.value, 'tamil')}
                                            />
                                        </p>
                                        <hr />
                                    </div>
                                ))
                            ) : (
                                <div>
                                    <p><strong>Post:</strong> {manualAddress.Name}</p>
                                    <p><strong>District:</strong> {manualAddress.District}</p>
                                    <p><strong>State:</strong> {manualAddress.State}</p>
                                    <p><strong>Country:</strong> {manualAddress.Country}</p>
                                    <p><strong>PIN Code:</strong> {manualAddress.Pincode}</p>
                                </div>
                            )}
                            <button onClick={approveAddress}>Add these Address Areas</button>
                        </div>
                    )}

                    {/* Manual Address Form for non-India countries */}
                    {country !== 'India' && !addressData && (
                        <div>
                            <h3>Manual Address Entry:</h3><br />
                            <label>Name of Area:</label>
                            <input
                                type="text"
                                name="Name"
                                value={manualAddress.Name}
                                onChange={handleManualAddressChange}
                                required
                            />
                            <br /><br />
                            <label>District:</label>
                            <input
                                type="text"
                                name="District"
                                value={manualAddress.District}
                                onChange={handleManualAddressChange}
                                required
                            />
                            <br /><br />
                            <label>State:</label>
                            <input
                                type="text"
                                name="State"
                                value={manualAddress.State}
                                onChange={handleManualAddressChange}
                                required
                            />
                            <br /><br />
                            <label>PIN Code:</label>
                            <input
                                type="text"
                                name="Pincode"
                                value={manualAddress.Pincode}
                                onChange={handleManualAddressChange}
                                maxLength={6}
                                required
                            />
                            <br /><br />

                            {/* Show the submit button for manual address */}
                            <button onClick={approveAddress}>Submit Address</button>
                        </div>
                    )}
                    <button onClick={() => navigate("/address/admin")}>முகவரி நிர்வாகம்</button>
                </div>

            </div>
        </div>
    );
};

export default PinCodeLookup;
